export default "__VITE_ASSET__NwcP0UWz__"